import React, { Component } from 'react';
import { Button, Col, DatePicker, Form, Input, message, Modal, Radio, Row, Select, TreeSelect } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import { getCompanyList } from '@store/modules/company_list';
import { getWorkOrgList } from '@store/modules/work_org_list';
import { getDepartmentList } from '@store/modules/department_list';
import UploadFile from '@comm/upload/UploadFile';
import CompanySearch from '@comm/companySearch';

import { queryHrInfo, queryHrList, queryHandover } from '@api/hr/hr';
import { queryDeleteAttachment } from '@api/pub/attachment';
import { queryOrgInfo } from '@api/core/org';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const getParentCompany = (key, tree, grandKeys) => {
  let parentKey;
  const grandKey = grandKeys || [];
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];

    if (node.children) {
      if (node.children.some(item => item.uuid === key)) {
        if (node.type === 2) {
          grandKey.push({ orgUuid: node.uuid, orgName: node.name });
        }
        parentKey = grandKey;
      } else if (getParentCompany(key, node.children)) {
        if (node.type === 2) {
          grandKey.push({ orgUuid: node.uuid, orgName: node.name });
        }
        parentKey = getParentCompany(key, node.children, grandKey);
      }
    }
  }
  return parentKey;
};

class FormStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
      delFiles: [],
      handoverVisible: false,
      successors: [],
      toUuid: undefined,
      handoverLoading: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(getCompanyList());
    this.props.dispatch(getWorkOrgList());
    if (this.props.orgUuid) {
      this.getOrgDetail();
    }
    if (this.props.uuid) {
      this.getDetail();
    }
  }

  formatDate = date => {
    return date ? moment(date).format('YYYY-MM-DD') : date;
  };

  getDetail = () => {
    queryHrInfo({ uuid: this.props.uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          detail: res.data,
        });
      }
    });
  };

  getDepartmentList = uuid => {
    this.props.dispatch(getDepartmentList({ uuid }));
  };

  getOrgDetail = () => {
    queryOrgInfo({ uuid: this.props.orgUuid }).then(res => {
      if (res.statusCode === 200) {
        if (res.data.type === 2) {
          this.comUuid = this.props.orgUuid;
          this.getDepartmentList(this.comUuid);
          this.props.form.setFieldsValue({ comName: res.data.name });
        } else if (res.data.type === 3) {
          this.deptUuid = this.props.orgUuid;
          const org = getParentCompany(this.props.orgUuid, this.props.orgTree).pop();

          this.comUuid = org.orgUuid;
          this.props.form.setFieldsValue({ comName: org.orgName });
          this.getDepartmentList(this.comUuid);
          this.props.form.setFieldsValue({ deptName: res.data.name });
        }
      }
    });
  };

  handleComChange = (value, option) => {
    this.getDepartmentList(value);
    this.props.form.setFieldsValue({
      comName: option.props.children,
      deptUuid: '',
      deptName: '',
    });
  };

  handleDepChange = (value, label, extra) => {
    this.props.form.setFieldsValue({ deptName: label[0] });
  };

  handleSave = e => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.uuid) {
          values.uuid = this.props.uuid;
        }
        this.formatParamDate(values);

        this.props.saveHr(values);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {});
            return item;
          });
        }
      }
    });
  };

  handleRegister = e => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.uuid) {
          values.uuid = this.props.uuid;
        }
        this.formatParamDate(values);

        this.props.registerHr(values);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {});
            return item;
          });
        }
      }
    });
  };

  formatParamDate = values => {
    if (values.sDate) {
      values.sDate = this.formatDate(values.sDate);
    }

    if (values.eDate) {
      values.eDate = this.formatDate(values.eDate);
    }

    if (values.inDate) {
      values.inDate = this.formatDate(values.inDate);
    }
    if (values.birthday) {
      values.birthday = this.formatDate(values.birthday);
    }
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  /**
   * 流程交接：搜索可选的接交人（启用人员）
   */
  searchSuccessor = value => {
    queryHrList({ condition: value, status: 1, limit: 50 }).then(res => {
      if (res.statusCode === 200) {
        this.setState({ successors: res.data });
      }
    });
  };

  handleHandoverVisible = flag => {
    if (flag) {
      this.searchSuccessor('');
    } else {
      this.setState({ toUuid: undefined });
    }
    this.setState({ handoverVisible: !!flag });
  };

  handleHandoverOk = () => {
    const { toUuid } = this.state;
    if (!toUuid) {
      message.error('请选择接交人!');
      return;
    }
    this.setState({ handoverLoading: true });
    queryHandover({ fromUuid: this.state.detail.accountUuid, toUuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({
          handoverVisible: false,
          toUuid: undefined,
          handoverLoading: false,
        });
      } else {
        this.setState({ handoverLoading: false });
        message.error(res.message);
      }
    });
  };

  format = data => {
    data.map(item => {
      item.title = item.name;
      item.value = item.uuid;
      item.key = item.uuid;
      if (item.children) {
        this.format(item.children);
      }
      return item;
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { workOrg } = this.props;
    const { detail } = this.state;
    const { departTree, orgTree } = this.props;
    const departmentList = departTree.length > 0 ? departTree : orgTree;
    this.format(departmentList);
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    getFieldDecorator('comName', {
      initialValue: detail.comName,
    });
    getFieldDecorator('deptName', {
      initialValue: detail.deptName,
    });
    return (
      <Form className="formStaff">
        <div style={{ marginBottom: 15 }}>
          <Button icon="save" style={{ marginRight: 10 }} onClick={this.handleSave}>
            保存
          </Button>
          {detail.accountUuid ? (
            ''
          ) : (
            <Button icon="save" style={{ marginRight: 10 }} onClick={this.handleRegister}>
              注册
            </Button>
          )}

          {detail.uuid ? (
            <span>
              <Button
                icon="delete"
                style={{ marginRight: 10 }}
                onClick={() => this.props.deleteHr(detail.uuid)}
              >
                删除
              </Button>
              {detail.status === 1 ? (
                <Button
                  icon="lock"
                  style={{ marginRight: 10 }}
                  onClick={() => this.props.disableHr(detail.uuid)}
                >
                  禁用
                </Button>
              ) : (
                <Button
                  icon="unlock"
                  style={{ marginRight: 10 }}
                  onClick={() => this.props.enableHr(detail.uuid)}
                >
                  启用
                </Button>
              )}
              <Button
                icon="rollback"
                style={{ marginRight: 10 }}
                onClick={() => this.props.resetHr(detail.uuid)}
              >
                重置密码
              </Button>
              {detail.accountUuid ? (
                <Button
                  icon="swap"
                  style={{ marginRight: 10 }}
                  onClick={() => this.handleHandoverVisible(true)}
                >
                  流程交接
                </Button>
              ) : null}
            </span>
          ) : null}
        </div>
        <Row>
          <Col span={12}>
            <FormItem {...ItemLayout} label="姓名">
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入姓名!' }],
                initialValue: detail.name,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="手机号码">
              {getFieldDecorator('mobile', {
                rules: [{ required: true, message: '请输入手机号码!' }],
                initialValue: detail.mobile,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="公司名称" {...ItemLayout}>
              {getFieldDecorator('comUuid', {
                rules: [{ required: true, message: '请选择归属公司' }],
                initialValue: detail.uuid ? detail.comUuid : this.comUuid,
              })(
                <CompanySearch
                  companyName={detail.comName}
                  companyUuid={detail.comUuid}
                  onChange={this.handleComChange}
                  {...this.props}
                />,
              )}
            </FormItem>
          </Col>

          <Col span={12}>
            <FormItem label="部门" {...ItemLayout}>
              {getFieldDecorator('deptUuid', {
                rules: [{ required: true, message: '请输入部门!' }],
                initialValue: detail.uuid ? detail.deptUuid : this.deptUuid,
              })(
                <TreeSelect
                  showSearch
                  treeNodeFilterProp="title"
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  treeData={departmentList}
                  treeDefaultExpandAll
                  onChange={this.handleDepChange}
                />,
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="职能部门" {...ItemLayout}>
              {getFieldDecorator('workOrgUuid', {
                initialValue: detail.workOrgUuid,
              })(
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {workOrg.map(item => (
                    <Option key={item.uuid}>{item.name}</Option>
                  ))}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="岗位级别" {...ItemLayout}>
              {getFieldDecorator('workLeave', {
                initialValue: detail.workLeave,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="薪资级别">
              {getFieldDecorator('incomeLeave', {
                initialValue: detail.incomeLeave,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="出生日期">
              {getFieldDecorator('birthday', {
                initialValue: detail.birthday ? moment(detail.birthday) : detail.birthday,
              })(<DatePicker />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="性别">
              {getFieldDecorator('sex', {
                initialValue: detail.sex,
              })(
                <RadioGroup {...ItemLayout}>
                  <Radio value={0}>女</Radio>
                  <Radio value={1}>男</Radio>
                </RadioGroup>,
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="民族">
              {getFieldDecorator('nation', {
                initialValue: detail.nation,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="身份证">
              {getFieldDecorator('idCard', {
                initialValue: detail.idCard,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="岗位">
              {getFieldDecorator('post', {
                initialValue: detail.post,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="学历">
              {getFieldDecorator('edu', {
                initialValue: detail.edu,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="进单位日期">
              {getFieldDecorator('inDate', {
                initialValue: detail.inDate ? moment(detail.inDate) : detail.inDate,
              })(<DatePicker />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="劳动合同起">
              {getFieldDecorator('sDate', {
                initialValue: detail.sDate ? moment(detail.sDate) : detail.sDate,
              })(<DatePicker />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="劳动合同止">
              {getFieldDecorator('eDate', {
                initialValue: detail.eDate ? moment(detail.eDate) : detail.eDate,
              })(<DatePicker />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="居住地">
              {getFieldDecorator('address', {
                initialValue: detail.address,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="邮箱">
              {getFieldDecorator('mail', {
                initialValue: detail.mail,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="QQ">
              {getFieldDecorator('qq', {
                initialValue: detail.qq,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...ItemLayout} label="微信号码">
              {getFieldDecorator('wxCode', {
                initialValue: detail.wxCode,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem {...ItemLayout2} label="其他信息">
              {getFieldDecorator('remark', {
                initialValue: detail.remark,
              })(<Input.TextArea rows={4} maxLength={1000} />)}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="附件" {...ItemLayout}>
              {getFieldDecorator('files', {
                initialValue: detail.files || [],
              })(
                <UploadFile
                  type="ghost"
                  fileList={detail.file}
                  isPreview
                  onRemove={this.fileRemove}
                />,
              )}
            </FormItem>
          </Col>
        </Row>
        <Modal
          title="流程交接"
          visible={this.state.handoverVisible}
          onOk={this.handleHandoverOk}
          onCancel={() => this.handleHandoverVisible(false)}
          confirmLoading={this.state.handoverLoading}
          destroyOnClose
        >
          <p style={{ marginBottom: 16 }}>
            将 <b>{detail.name}</b> 的流程审批交接给：
          </p>
          <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="请选择接交人"
            value={this.state.toUuid}
            onChange={value => this.setState({ toUuid: value })}
            onSearch={this.searchSuccessor}
            filterOption={false}
          >
            {this.state.successors.map(item => (
              <Option key={item.accountUuid} value={item.accountUuid}>
                {item.name}
                {item.workOrgName ? ` (${item.workOrgName})` : ''}
              </Option>
            ))}
          </Select>
        </Modal>
      </Form>
    );
  }
}

export default connect(state => ({
  company: state.company_list,
  workOrg: state.work_org_list,
  orgTree: state.enable_org_tree,
  departTree: state.department_list,
}))(Form.create({ wrappedComponentRef: true })(FormStaff));



// WEBPACK FOOTER //
// ./src/components/hr/staff/FormStaff.js